import { createRenderer } from 'fela'
import webPreset from 'fela-preset-web'
import namedKeys from 'fela-plugin-named-keys'
import embedded from 'fela-plugin-embedded'
import rtl from 'fela-plugin-rtl'

export default (theme, enhancers = [], additionalKeys = {}, selectorPrefix = '') => {
  const min = theme.mediaQuery.min(theme.breakpoints)
  const max = theme.mediaQuery.max(theme.breakpoints)
  const direction = theme.direction || 'ltr' // set left-to-right if not in the theme
  const renderer = createRenderer({
    enhancers,
    mediaQueryOrder: [max.small, min.medium, max.medium, min.large, max.large, min.xlarge],
    plugins: [
      ...webPreset,
      namedKeys({
        'screen-xlarge': `@media ${min.xlarge}`,
        'screen-large': `@media ${min.large}`,
        'screen-medium': `@media ${min.medium}`,
        'screen-large-max': `@media ${max.large}`,
        'screen-medium-max': `@media ${max.medium}`,
        'screen-small-max': `@media ${max.small}`,
        'supports-sticky': '@supports ((position: -webkit-sticky) or (position: sticky))',
        ...additionalKeys
      }),
      embedded(),
      rtl(direction)
    ],
    selectorPrefix
  })

  renderer.renderStatic(theme.baseOverrides)

  return renderer
}
